// Auth configuration
export var auth = {
  azureAdB2CInstance: 'https://login.microsoftonline.com/tfp',
  clientId: 'd432961e-42de-4966-b162-5917fee4c204', // 'd432961e-42de-4966-b162-5917fee4c204', // '4c4463f3-c454-47cd-afd5-876c4c235570',
  tenant: 'geodktestapi.onmicrosoft.com',
  signInPolicyId: 'B2C_1A_signin',
  apiScope:
    'https://geodktestapi.onmicrosoft.com/api-test-api.services.geodanmark.nu/access',
};

// Api configuration
export const api = {
  userMeUrl: 'https://api-test-api.services.geodanmark.nu/brugere/mig',
  objectGroupUrl:
    'https://api-test-api.services.geodanmark.nu/specifikationer/1/objektgrupper',
};
